module.exports = __webpack_public_path__ + "img/icon-contract-mew.5cb59b09.svg";